export default __webpack_public_path__ + "static/media/China.7dd6fd69.svg";